import { bindable } from "aurelia-typed-observable-plugin";
import { ProcoreSynchronizationResultDifferenceModel } from "api/models/procore/synchronization/procore-synchronization-result-difference-model";

export class SynchronizationPropertiesTable {

    @bindable
    public differences: ProcoreSynchronizationResultDifferenceModel | null = null;
}
